export default "__VITE_ASSET__DAxFMZn4__"